import React from "react";
import "./Intro.css";

function Intro() {
  return (
    <div className="hero__container">
      <div className="hero__content">
        <h1>Välkommen till Isaks Bilar!</h1>
        <p className="intro-subtitle">Din butik för de bästa leksaksbilarna och modellbilarna</p>
        <p className="intro-description">Hos oss hittar du allt från Hot Wheels och LEGO till Siku och RC-bilar. Perfekt för både samlare och barn som älskar bilar!</p>
      </div>
      <div className="hero__video">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline
          className="hero-video"
        >
          <source src="/images/Isaks_Bilar_E_handel_och_Video.mp4" type="video/mp4" />
          Din webbläsare stöder inte video-elementet.
        </video>
      </div>
    </div>
  )
}
export default Intro;
